// extracted by mini-css-extract-plugin
module.exports = {"ProjectsBox":"Projects_ProjectsBox__1F6IX","ContactButtonBox":"Projects_ContactButtonBox__aNjV4"};